<!--
    Program: ImeiReview.vue
    Author: SDL
    Description: 
    Created: 2020.03.20
-->

<template>
    <!-- contents -->
    <div>
        <div class="sub_tit">ESN Review</div>
        <!-- srchTop_wrap -->
        <div class="srchTop_wrap srch_result mb-20" style="padding: 20px !important;">
            <article class="srch_basic clear">
                <dl class="dl_search w100p">
                    <dd class="clearable" data-input-type="input">
                        <input
                            type="tel"
                            class="text_input w30p"
                            placeholder="Enter S/N"
                            pattern="[a-zA-Z0-9_-,]+"
                            v-regex="/[^0-9A-Za-z,_-]/g"
                            minlength="11"
                            maxlength="320"
                            ref="psn"
                            v-model="psn"
                            @keyup.enter.stop="onAddClick"
                        /> 
                        <a href="javascript:" class="btn_srch col_white"
                            @click="onAddClick">
                            Add
                        </a>
                    </dd>
                    <dd class="btn">
                        <a href="javascript:" class="btn_srch" @click="onSearchClick">Search</a>
                    </dd>
                </dl>
            </article>
        </div>

        <div class="grid_wrap">
            <div id="grid">
                <toast-grid
                    gridId="gridPsn"
                    :key="gridKey"
                    :data="gridData"
                    :columns="gridColumns"
                    :header="gridHeader"
                    :options="gridOptions"
                    :pageOptions="gridPageOptions"
                    :theme="gridTheme"
                    :isTotalCount="false"
                    v-bind:click="gridItemClick"
                />
            </div>
        </div>
        <!--//list table-->
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'query-string';
import { SDLUtil, StringUtil, DateUtil } from '@/utils';

import ToastGrid from '~c/ToastGrid';

import { CellHtmlRenderer, HeaderHtmlRenderer, ButtonRenderer } from '~c/GridCustomRenderer';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';

export default {
    name: 'psnReview',
    components: {
        'toast-grid': ToastGrid,
    },
    props: [],
    computed: {},
    data() {
        return {
            psn: '', // Product S/N (Serial Number)

            psnList: [],
            repetitionPsnList: [],
            unqualifiedPsnList: [],
            // resultCount: 0,

            // currentPage: 1,
            // perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,
            gridData: [],
            gridHeader: {
                // height: 100,
                //complexColumns: []
                columns: [
                    {
                        name: 'export_country',
                        renderer: HeaderHtmlRenderer,
                    },
                    {
                        name: 'validity',
                        renderer: HeaderHtmlRenderer,
                    },
                ],
            },
            gridColumns: [
                {
                    header: 'DELETE',
                    name: 'DELETE',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: { type: ButtonRenderer, options: { text: 'Delete' } },
                },
                {
                    header: 'ESN', // PREFIX = '000' 일 때 CODE_NAME
                    name: 'imei',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'MODEL',
                    name: 'model',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                }, 
                {
                    header: 'SKU',
                    name: 'item',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'SERIAL NUMBER',
                    name: 'prod_sn',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'SHIPPING DATE',
                    name: 'export_date',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'SHIPPING COUNTRY',
                    name: 'export_country',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'BUYER',
                    name: 'buyer',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'PROD.DATE',
                    name: 'prod_date',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'SALES DATE',
                    name: 'sales_date',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
            gridPageOptions: null,
        };
    },
    created() {
        console.log('Component: psnReview created. ');
        // this.postTestRequest();
    },
    mounted() {
        console.log('Component: psnReview mounted.');
    },
    methods: {

        onAddClick() {
        	let psnArr = this.psn.split(",");
        	let notNullpsnArr = [];
        	
        	for(const psn of psnArr){
        		psn = psn.trim();
        		if(psn.length !== 0){
        			psn = psn.replace(/[^0-9A-Za-z,_-]/g, ''); 
        			notNullpsnArr.push(psn);
        		}	
        	}
        	
        	for(const psn of notNullpsnArr ){
        		const success = this.addPsn(psn);  
                window.setTimeout(() => {
                    this.$refs.psn.focus();
                }, 200);                
                this.psn = '';
        	} 
             
            if(this.unqualifiedPsnList.length > 0 && this.repetitionPsnList.length > 0 ){
       		 SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Unqualified data length PSN:['+this.unqualifiedPsnList+'];<br>'+'Repetitive PSN：['+this.repetitionPsnList+']',
                });
       		 		this.repetitionPsnList=[];
    				this.unqualifiedPsnList=[];
                return;
       	}
       	
			if(this.unqualifiedPsnList.length > 0  ){
				 SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Unqualified data length PSN:['+this.unqualifiedPsnList+']',
                });
				 	this.unqualifiedPsnList=[];
                return;
       	}
			
			if(this.repetitionPsnList.length > 0  ){
				 SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Repetitive PSN：['+this.repetitionPsnList+']',
                });
				 	this.repetitionPsnList=[];
                return;
       	}
           
        },
        
        addPsn(psn) {
            psn = String(psn).toUpperCase();

            if (psn.length < 10 || psn.length > 15) {                 
            	this.unqualifiedPsnList.push(psn);
            	return false;
            }
            
            if (this.psnList.find(item => item === psn)) {
            	this.repetitionPsnList.push(psn);
                return false;
            }
           
            this.gridData.push({
                imei: psn,
            });

            // this.psnList.push(psn);
            this.psnList = this.gridData.map(item => item.imei);

            this.gridKey += 1;
            return true;
        },


        async onSearchClick() {
            if (this.psnList.length === 0) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please add PSN to check',
                })
                return;
            }
            const data = await this.fetchResult()
                .catch(err => {
                    SDLUtil.alert({
                        title: 'Server Error',
                        msg: 'Error while getting data from server.',
                    });
                    return null;
                });
            if (data == null) return; 
            this.setData(data.result);

        },

        fetchResult() {
            const path = '/basis/anysvcmobile/imeiReview/IMEIReviewSearchAjax.skp';
            const formData = {
                imei: this.psnList, // Server wants 'imei'
                model: 'NONE',
            };
            return SDLUtil.postForm(path, formData);
        },

        gridItemClick(e, rows) {
            console.log('selectGridItem', e, rows);
            const rowIdx = e.rowKey;
            // const gridItem = this.gridData[rowIdx];
            if (e.columnName === 'DELETE') {
                this.deleteItem(rowIdx)
            }
        },

        setData(data) {
            this.gridData = this.gridData.map(item => {
                const newData = data.find(dItem => dItem.imei === item.imei);
                if (newData.result === 'E') {
                    newData.model = newData.output;
                }
                return newData;
            });
            // this.gridData = data;
            this.gridKey += 1;
        },

        deleteItem(rowIdx) {
        	this.gridData = this.gridData.filter(item => item.rowKey !== rowIdx); 
            this.psnList = this.gridData.map(item => item.imei);
            this.gridKey += 1;
        },
    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/imeiReview/PsnReview.vue